import {Routes} from "@angular/router";
import {LegalRoutes} from "./_models/_enums/LegalRoutes";
import {SettingsComponent} from "./settings/settings.component";
import {AuthGuard} from "../../_auth/auth.guard";
import {PermissionService} from "../../_auth/permission.service";
import {TechnicalSecuritySystemComponent} from "./technical-security-system/technical-security-system.component";
import {DataExportsComponent} from "./exports/data-exports.component";
import {TseExportsComponent} from "./exports/tse-exports.component";
import {ClosingCorrectionsComponent} from "./closing-corrections/closing-corrections.component";

export const LEGAL_ROUTES: Routes = [
  {
    path: LegalRoutes.Settings,
    component: SettingsComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.Permissions_LegalSettingsComponent().default},
    title: "Rechtliche Einstellungen"
  },
  {
    path: LegalRoutes.TSS,
    component: TechnicalSecuritySystemComponent,
    canActivate: [AuthGuard],
    // `routeData()` rather than `.default` (#769): `.default` DISCARDS `anyRoles`, and `anyRoles` is the only
    // thing a `Steuerberater` session matches on — it carries that one central role and no legacy
    // endpoint-permission id at all, so with `.default` alone the guard would refuse the very screen the role
    // exists for. Same trap, same fix as the company routes in `app.routes.ts`.
    //
    // `fiscal: true` is the opt-in half of the confinement in `auth.guard.ts`: a session whose ONLY destination
    // role is `Steuerberater` may reach the routes that carry this flag and is bounced to
    // `AppRoutes.LegalTse` everywhere else. Stories #770/#771 flag their own screens the same way — the flag is
    // the shared convention, there is no shared list to keep in step.
    data: {...PermissionService.Permissions_LegalTSEComponent().routeData(), fiscal: true},
    title: "TSE"
  },
  {
    // #770 — the DSFinV-K data export. Gated to the same set the SURFACE behind it admits, so a tax adviser
    // cannot be let onto the route and then refused by every request on it (or the other way round), and
    // `routeData()` rather than `.default` for the reason the TSE route records above: `.default` discards
    // `anyRoles`, which is the only thing a `Steuerberater` session matches on.
    //
    // `fiscal: true` opts this screen into the confinement in `auth.guard.ts` — a session whose only
    // destination role is `Steuerberater` may reach the flagged routes and is bounced everywhere else. This is
    // the second such route (#769 registered the first).
    path: LegalRoutes.Exports,
    component: DataExportsComponent,
    canActivate: [AuthGuard],
    data: {...PermissionService.Permissions_LegalExportsComponent().routeData(), fiscal: true},
    title: "DSFinV-K-Datenexport"
  },
  {
    // #776 — the TSE data export. Same gate, same `fiscal: true` confinement and the same `routeData()` rather
    // than `.default` as the two routes above, for the reason the TSE route records: `.default` discards
    // `anyRoles`, which is the only thing a `Steuerberater` session matches on. This is the third flagged
    // route.
    path: LegalRoutes.TseExports,
    component: TseExportsComponent,
    canActivate: [AuthGuard],
    data: {...PermissionService.Permissions_LegalTseExportsComponent().routeData(), fiscal: true},
    title: "TSE-Datenexport"
  },
  {
    // #771 — correcting filed cash point closings. Same gate as the exports (the four roles #770 admits), the
    // same `routeData()` rather than `.default` so a tax adviser's `anyRoles` survives, and the same
    // `fiscal: true` opt-in to the Steuerberater confinement. The fourth flagged route.
    path: LegalRoutes.ClosingCorrections,
    component: ClosingCorrectionsComponent,
    canActivate: [AuthGuard],
    data: {...PermissionService.Permissions_LegalClosingCorrectionsComponent().routeData(), fiscal: true},
    title: "Kassenabschluss erneut übermitteln"
  },
  {
    path: '**', redirectTo: '/', pathMatch: 'full'
  }
]
